import ComponentHelper from '../../supers/ComponentHelper';
import Modal from 'react-modal';
import React from 'react';
import './multi-step-modal.css';

class MultiStepModal extends ComponentHelper {
	constructor(props) {
		super(props);
		this.setInitialData(props);
		this.autoBind([
			'getNextDisabled',
			'onNextStep',
			'onPreviousStep',
			'getStepContent',
			'showPrevious',
			'buildHeaderItems',
			'getStepText',
			'getStepBtnText'
		]);
	}

	setInitialData = props => {
		let { steps, title } = props;
		this.data = {
			animationCls: 'zoomIn',
			steps: steps || {},
			title: title || '',
			stepNum: 0
		};
	};

	// Clear component state when modal is re-open
	componentWillReceiveProps(nextProps) {
		if (!this.props.isOpen && nextProps.isOpen) {
			this.observe(() => {
				this.setInitialData(nextProps);
			});
		} else if (this.props.isOpen && nextProps.isOpen) {
			this.observe(() => {
				this.data.steps = nextProps.steps;
			});
		}
	}

	onClose = () => {
		this.setData('animationCls', 'zoomOut');
		setTimeout(() => {
			this.props.onClose();
		}, 200);
	};

	buildHeaderItems() {
		let stepNum = this.data.stepNum;
		let keys = Object.keys(this.data.steps);
		let items = [];
		for (let i = 0; i < keys.length; i++) {
			let stepName = keys[i];
			items.push(
				<div
					key={i}
					className={`bar-item vbox hcenter vcenter ${
						stepNum === i ? `active ${stepNum === keys.length - 1 ? 'right' : `${stepNum === 0 ? 'left' : ''}`}` : ''
					}`}
				>
					{stepName}
				</div>
			);
		}
		return items;
	}

	getStepText() {
		let step = this.getCurrentStep();
		return (step && step.text) || '';
	}

	getCurrentStep = () => {
		let step = {};
		try {
			step = Object.values(this.data.steps)[this.data.stepNum];
			if (!step && Object.keys(this.data.steps).length > 0) {
				step = Object.values(this.data.steps)[0];
			}
		} catch (err) {
			console.error(err);
		}
		return step;
	};

	getNextDisabled() {
		let step = this.getCurrentStep();
		if (step && step.validator) {
			return !step.validator();
		}
		return false;
	}

	onNextStep() {
		if (Object.keys(this.data.steps).length === this.data.stepNum + 1) {
			let step = this.getCurrentStep();
			step.onNext();
		} else {
			this.setData('stepNum', this.data.stepNum + 1);
		}
	}

	onPreviousStep() {
		this.setData('stepNum', this.data.stepNum - 1);
	}

	getStepBtnText() {
		let step = this.getCurrentStep();
		return (step && step.nextText) || 'Next';
	}

	getStepContent() {
		let step = this.getCurrentStep();
		return (step && step.content) || '';
	}

	showPrevious() {
		return this.data.stepNum > 0;
	}

	getLoading() {
		let s = this.getCurrentStep();
		if (!s || s.loading) {
			return 'hidden';
		}
		return '';
	}

	render() {
		let { isOpen, className } = this.props;
		let { animationCls, title, stepNum } = this.data;
		return (
			<Modal
				contentLabel="Modal"
				isOpen={isOpen}
				className={`multi-step-modal animated ${animationCls} ${className ? className : ''} ${'step-' + stepNum}`}
				overlayClassName="dialog-modal-overlay vbox hcenter vcenter"
				ariaHideApp={false}
			>
				<div className="modal-header">{title}</div>
				<div className="step-bar hbox vcenter">{this.buildHeaderItems()}</div>
				<div className="step-text">{this.getStepText()}</div>
				<div className="modal-body">{this.getStepContent()}</div>
				<div className={`btn-ctn ${this.getLoading()}`}>
					<button className="btn cancel-btn" onClick={this.onClose}>
						Cancel
					</button>
					<div className="w-100" />
					<button className={`btn dark m-r-20 ${this.showPrevious() ? '' : 'hidden'}`} onClick={this.onPreviousStep}>
						Previous
					</button>
					<button className="btn primary" onClick={this.onNextStep} disabled={this.getNextDisabled()}>
						{this.getStepBtnText()}
					</button>
				</div>
			</Modal>
		);
	}
}
export default MultiStepModal;



// WEBPACK FOOTER //
// ./src/components/multi-step-modal/MultiStepModal.js